import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector }   from 'react-redux';
import { useTranslate,useDomain }     from '../../../../hooks/use'  
import UiKit                            from "../../../../common/uikit"
// import axios from 'axios';

const SignInForm = ({ history }) => {
    const [ formData, setFormData ]     = useState({ loginEmail: '', loginPassword: '' });
    const [ errors, setErrors ]         = useState({ errors: {} });
    const { account }                   = useDomain({ Account: {} })
    const dispatch                      = useDispatch();
    const t                             = useTranslate();
    const { isLoading, isLoginError }   = useSelector( state => ({ 
        isLoading                   : state.getIn([ 'ui', 'provider', 'isLoading', 'Start_Login']),
        isLoginError                : state.getIn([ 'ui', 'runtime', 'viewData', 'signIn', 'isLoginError']),
    }))
    const s = formData;
    const [showPassword, setShowPassword] = useState(false);

    const getLoginError = (type) => {
        return isLoginError 
            ? type === 'loginEmail'
                ? [{ message: 'Please check your email.' }]
                : [{ message: 'Please check your password.' }]
            : null
    }

    const changeFormValues = (node, value) => {
        setFormData({ ...formData, [node]: value })
    }

    
    const startLogin = (e) => {
        // const data = {
        //     user_email: "bijanetessam@gmail.com",
        //     user_password: "m000000Q",
        //   }
        //   axios.defaults.withCredentials = true;
        //   axios.post('https://web-project-july-2021.herokuapp.com/api/user/login',data,{
        //     withCredentials: true,
        //     credentials: 'include',
        //   })

        const validationResult = account.startLogin({
            data: {
                email    : s.loginEmail, 
                password : s.loginPassword,
            }
        });
        if(!validationResult.valid) {
            setErrors(validationResult.fields);
        }
    };
    
    const changeShowPassword = () => {
        setShowPassword(!showPassword);
    }

    return (
        <div className='loginpage-container'>
            <form className='loginpage-form'>
            <UiKit.Row>
                    <UiKit.Col sm="12" md="12">
                        <div className="loginpage-form-img"></div>
                    </UiKit.Col>
                </UiKit.Row>
                <UiKit.Row className="mt25">
                    <UiKit.Col sm="12" md="12">
                        <UiKit.Textfield
                            placeholder = "Mail adresini giriniz..."
                            type        = { 'email' }
                            full        = { true }
                            attrs       = {{ id : 'login-email' }}
                            maxLength   = { 128 }
                            isDisabled  = { isLoading }
                            value       = { s.loginEmail }
                            onChange    = { value => changeFormValues('loginEmail', value) }
                            autoFocus
                        />
                    </UiKit.Col>
                </UiKit.Row>
                <UiKit.Row className="mt20">
                    <UiKit.Col sm="12" md="12">
                        <UiKit.Textfield
                            placeholder = "Şifrenizi giriniz..."
                            type        = { showPassword ? 'text' : 'password' }
                            full        = { true }
                            attrs       = {{ id: 'login-password' }}
                            isDisabled  = { isLoading }
                            value       = { s.loginPassword }
                            onChange    = { value => changeFormValues('loginPassword', value) }
                        />
                    </UiKit.Col>
                    <UiKit.Col sm="12" md="12">
                        <div className="loginpage-password">
                            <div className="loginpage-password-wrap">
                            {
                                showPassword
                                ? <i className = "fas fa-eye-slash" onClick = { changeShowPassword }></i>
                                : <i className = "fas fa-eye" onClick = { changeShowPassword }></i>
                            }
                            </div>
                            <label onClick = { changeShowPassword }>Şifreyi göster</label>
                        </div>
                    </UiKit.Col>
                </UiKit.Row>
                <UiKit.Row>
                    <UiKit.Col className="mt20" sm="12" md="12">
                        <UiKit.Button
                            isCustomLabelType
                            label       = "Giriş Yap"
                            full        = { true }
                            isLoading   = { isLoading }
                            isDisabled  = { isLoading }
                            onClick     = { () => startLogin() }
                        />
                    </UiKit.Col>
                </UiKit.Row>
            </form>
        </div>
    );
};
export default SignInForm;